import { Builder, withChildren } from '@builder.io/react'

const MaxWidthContainer = ({
  children,
  classNames = ''
}) => {
  return (
    <div className={`mx-auto px-4 sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1200px] 2xl:max-w-[1400px] ${classNames}`}>
      {children} {/* Ensure children are rendered */}
    </div>
  )
}

// Wrap the MaxWidthContainer with withChildren to make it support children
const containerWithChildren = withChildren(MaxWidthContainer)

// Register the component with Builder.io
Builder.registerComponent(containerWithChildren, {
  name: 'MaxWidthContainer',
  canHaveChildren: true,
  inputs: [
    {
      name: 'classNames',
      type: 'string',
      friendlyName: 'Additional Tailwind Classes for Container',
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'div',
        options: {
          text: 'Insert other content here to fit in a best possible layout',
        },
      },
    },
  ],
})

export default MaxWidthContainer
